import { render, staticRenderFns } from "./TipoEmolumento.vue?vue&type=template&id=2a99a788&scoped=true&"
import script from "./TipoEmolumento.vue?vue&type=script&lang=js&"
export * from "./TipoEmolumento.vue?vue&type=script&lang=js&"
import style0 from "./TipoEmolumento.vue?vue&type=style&index=0&id=2a99a788&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a99a788",
  null
  
)

export default component.exports